export default __webpack_public_path__ + "static/media/AtkinsonHyperlegibleMono-Medium.f9519531.woff2";